import { Box } from "@mui/material";

export const TabPanel = ({ value, index, children }) => {
  return <Box hidden={value !== index}>{children}</Box>;
};
